export const MAX_EMAIL_LENGTH = 100
export const MAX_NAME_LENGTH = 50

export const MAX_ORDER_COMMENT_LENGTH = 500
export const MAX_DESCRIPTION_LENGTH = 500

export const MAX_COUNT_VALUE = 9999
export const MAX_PRICE_VALUE = 999999

export const CVR_LENGTH = 8 // DK CVR: 8 digits
export const EAN_LENGTH = 13 // Standard EAN length

export const POSTAL_CODE_LENGTH = 4
export const POSTAL_CODE_REGEX = /^\d{4}$/u

export const PHONE_REGEX = /^[0-9+\-() ]+$/u
export const MAX_PHONE_LENGTH = 20
